module.exports = __webpack_public_path__ + "static/img/iconfontnew.c8af719.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/fonts/iconfontnew.svg?v=1.0.0
// module id = ElCi
// module chunks = 35